var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "ruleForm",
      staticClass: "transport-require",
      attrs: { model: _vm.ruleForm, "label-width": "100px" }
    },
    [
      _c(
        "div",
        { staticClass: "transport-require-box" },
        [
          _c(
            "el-form-item",
            { attrs: { label: "期望车型", prop: "expectTruckType" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入期望车型" },
                model: {
                  value: _vm.ruleForm.expectTruckType,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "expectTruckType", $$v)
                  },
                  expression: "ruleForm.expectTruckType"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "期望车长", prop: "expectTruckLength" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入期望车长" },
                model: {
                  value: _vm.ruleForm.expectTruckLength,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "expectTruckLength", $$v)
                  },
                  expression: "ruleForm.expectTruckLength"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "货最长", prop: "goodsLongest" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入货最长" },
                model: {
                  value: _vm.ruleForm.goodsLongest,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "goodsLongest", $$v)
                  },
                  expression: "ruleForm.goodsLongest"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "货最宽", prop: "goodsWidth" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入货最宽" },
                model: {
                  value: _vm.ruleForm.goodsWidth,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "goodsWidth", $$v)
                  },
                  expression: "ruleForm.goodsWidth"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          staticClass: "request-label",
          attrs: { label: "要求标签", prop: "name" }
        },
        [
          _c(
            "div",
            { staticClass: "tags-wrapper" },
            _vm._l(_vm.tags, function(item, index) {
              return _c(
                "span",
                {
                  key: index,
                  staticClass: "tag",
                  class: { chosed: item.selected },
                  on: {
                    click: function($event) {
                      return _vm.doAdd(index)
                    }
                  }
                },
                [_vm._v(_vm._s(item.text))]
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "运输备注", prop: "notes" } },
        [
          _c("el-input", {
            attrs: { type: "textarea", placeholder: "请输入运输备注" },
            model: {
              value: _vm.ruleForm.notes,
              callback: function($$v) {
                _vm.$set(_vm.ruleForm, "notes", $$v)
              },
              expression: "ruleForm.notes"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-f720328e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-f720328e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/deliver/components/transportRequire/index.vue
// module id = null
// module chunks = 